import appStore from './zh-TW/app-store';
import applicationCatalog from './zh-TW/application-catalog';
import applicationCenter from './zh-TW/application-center';
import applicationFeedback from './zh-TW/application-feedback';
import businessAppMarket from './zh-TW/business-app-market';
import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import markets from './zh-TW/markets';
import menu from './zh-TW/menu';
import myApps from './zh-TW/my-apps';
import navigation from './zh-TW/navigation';
import pages from './zh-TW/pages';
import platformSettings from './zh-TW/platform-settings';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import workbench from './zh-TW/workbench';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.footer.copyright': '2026 珊瑚智成（北京）科技有限公司',
  'app.preview.down.block': '下載此頁面到本地項目',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...navigation,
  ...workbench,
  ...applicationCatalog,
  ...applicationCenter,
  ...applicationFeedback,
  ...businessAppMarket,
  ...markets,
  ...myApps,
  ...appStore,
  ...platformSettings,
};
